/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_MarkerInputs */

const en_how_we_work_brief_marker = /** @type {(inputs: How_We_Work_Brief_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative`)
};

const lv_how_we_work_brief_marker = /** @type {(inputs: How_We_Work_Brief_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs`)
};

/**
* | output |
* | --- |
* | "Illustrative" |
*
* @param {How_We_Work_Brief_MarkerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_marker = /** @type {((inputs?: How_We_Work_Brief_MarkerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_MarkerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_marker(inputs)
	return en_how_we_work_brief_marker(inputs)
});